import WishlistButtonEvents from '../../tracking/wishlist/wishlistButtonEvents';
import WishlistEvents from '../../tracking/wishlist/wishlistEvents';
import { register } from '../../core/bootstrapper';

register('wishlist', function() {
  new WishlistEvents();
  new WishlistButtonEvents();
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/wishlist/trackingBootstrap.js
 **/